"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = copy;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function copy(_x) {
  return _copy.apply(this, arguments);
}

function _copy() {
  _copy = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(text) {
    var textArea;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!navigator.clipboard) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return navigator.clipboard.writeText(text);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
            textArea = document.createElement('textarea');
            textArea.value = text; // Avoid scrolling to bottom

            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.position = 'fixed';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
              document.execCommand('copy');
            } catch (err) {
              console.error('Fallback: Oops, unable to copy', err);
            }

            document.body.removeChild(textArea);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _copy.apply(this, arguments);
}